var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1424_17668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85854 3.64453C2.44177 3.64453 2.04207 3.81009 1.74737 4.10479C1.45267 4.39949 1.28711 4.79919 1.28711 5.21596V20.1445C1.28711 20.5613 1.45267 20.961 1.74737 21.2557C2.04207 21.5504 2.44177 21.716 2.85854 21.716H20.1443C20.561 21.716 20.9607 21.5504 21.2554 21.2557C21.5501 20.961 21.7157 20.5613 21.7157 20.1445V5.21596C21.7157 4.79919 21.5501 4.39949 21.2554 4.10479C20.9607 3.81009 20.561 3.64453 20.1443 3.64453H17.0014",
    stroke: "#525252",
    strokeWidth: 1.27204,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00195 1.28711V6.0014",
    stroke: "#525252",
    strokeWidth: 1.27204,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.002 1.28711V6.0014",
    stroke: "#525252",
    strokeWidth: 1.27204,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.64453H13.8571",
    stroke: "#525252",
    strokeWidth: 1.27204,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4294 13.0723H7.57227",
    stroke: "#525252",
    strokeWidth: 1.27204,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.14453V17.0017",
    stroke: "#525252",
    strokeWidth: 1.27204,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1424_17668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCalendarIcon);
export default __webpack_public_path__ + "static/media/add-calendar-icon.504b96b9e869f3196f3a6ccb7fde977b.svg";
export { ForwardRef as ReactComponent };